import { render, staticRenderFns } from "./BrowserPaying.vue?vue&type=template&id=4c0a5e4c&scoped=true&"
import script from "./BrowserPaying.vue?vue&type=script&lang=js&"
export * from "./BrowserPaying.vue?vue&type=script&lang=js&"
import style0 from "./BrowserPaying.vue?vue&type=style&index=0&id=4c0a5e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a5e4c",
  null
  
)

export default component.exports